import {
  confirmDialog,
  CustomCollapseCard,
  CustomPagination,
  CustomTable,
  successDialog,
  Text,
  useText,
} from '@src/components';
import React, { useCallback } from 'react';
import '@src/styles/manageMyCards/canceledCardList.scss';
import { useDispatch, useSelector } from 'react-redux';
import { cancelRequestsDelete, cardGetPagedList } from '@src/store/slice/manageMyCardsSlice';
import { handleAuthStatus } from '@src/utils/utils';
import { VirtualizedAndLazyScrollTable } from '@src/components/VirtualizedAndLazyScrollTable';
import CardFilter from './CardFilter';

const CanceledCardList = () => {
  const dispatch = useDispatch();
  const { list, tableProperty, filterObject } = useSelector((state) => state?.manageMyCards);
  const confirmDialogMessage = useText('giveUpCancellationText');
  const cardList = useText('cardList');
  const cardNumber = useText('cardNumber4');
  const name = useText('nameUpperCase');
  const surname = useText('surnameUpperCase');
  const referenceCode = useText('referenceCode3');
  const phoneNumber = useText('phoneNumberUpperCase');
  const actionUpperCase = useText('actionUpperCase');
  const { userAuthorizationStatus } = useSelector((state) => state?.user);

  const handleTableChange = useCallback(
    async (pageNumber, pageSize) => {
      await dispatch(cardGetPagedList({ body: {}, ...filterObject, pageNumber, pageSize }));
    },
    [dispatch, filterObject],
  );
  const yourTransactionHasBeenSuccessfullyCompleted = useText('yourTransactionHasBeenSuccessfullyCompleted');

  const cancelCancellation = useCallback(
    async (record) => {
      confirmDialog({
        title: <Text t="attention" />,
        message: confirmDialogMessage,
        onOk: async () => {
          const action = await dispatch(cancelRequestsDelete({ cswId: record?.cswId }));
          if (cancelRequestsDelete.fulfilled.match(action)) {
            successDialog({
              title: <Text t="success" />,
              message: action?.payload?.message || yourTransactionHasBeenSuccessfullyCompleted,
              onOk: async () => {
                await dispatch(cardGetPagedList({ ...filterObject }));
              },
              onCancel: () => { },
            });
          }
        },
      });
    },
    [dispatch, filterObject],
  );

  const columns = [
    {
      title: cardNumber,
      dataIndex: 'cardNumber',
      key: 'cardNumber',
      width: 162.7,
    },
    {
      title: name,
      dataIndex: 'name',
      key: 'name',
      width: 150,
    },
    {
      title: surname,
      dataIndex: 'surname',
      key: 'surname',
      width: 150,
    },
    {
      title: referenceCode,
      dataIndex: 'refNo',
      key: 'refNo',
      width: 135,
      align: 'left',
    },
    {
      title: phoneNumber,
      dataIndex: 'gsm',
      key: 'gsm',
      width: 130,
    },
  ];
  !handleAuthStatus(userAuthorizationStatus, 'ManageMyCardsCancelCancellation') &&
    columns.push({
      title: actionUpperCase,
      dataIndex: 'action',
      key: 'action',
      width: 150,
      align: 'center',
      render: (_, record) => {
        if (record?.cswId) {
          return (
            <span className="recanceled-btn" onClick={() => cancelCancellation(record)}>
              <Text t="cancelCancellation" />
            </span>
          );
        } else {
          return (
            <span>
              <Text t="cannotBeCancelled" />
            </span>
          );
        }
      },
    });
  return (
    <CustomCollapseCard cardTitle={cardList} className="canceled-card-list-card">
      <CardFilter />
      <VirtualizedAndLazyScrollTable
        pagination={false}
        dataSource={list}
        columnsData={columns}
        rowKey={(record) => `manage-my-card-${record?.id}`}
        getDataFunc={async (_, pageSize) => {
          await handleTableChange(1, pageSize);
        }}
      />
    </CustomCollapseCard>
  );
};

export default CanceledCardList;
